export const isArnoldBrosRewardBands = (
  rewardBands:
    | BonusTypes.Rewards.RewardBands
    | BonusTypes.Rewards.ArnoldBrosRewardBands,
): rewardBands is BonusTypes.Rewards.ArnoldBrosRewardBands =>
  'components' in rewardBands;

export const isArnoldBrosDriverRewardsOutput = (
  output: BonusTypes.Rewards.AnyDriverRewardsOutput,
): output is BonusTypes.Rewards.ArnoldBrosDriverRewardsOutput =>
  'version' in output;

/**
 * A reward output is "general" (the v3.x `multiplierBanded` / `aggregated` shape)
 * when it does not carry the Arnold Bros `components` band structure. The Arnold
 * program's `version` output guard can't distinguish v2.x (component ladders)
 * from v3.x (general shape), so distinguish on the band structure instead.
 */
export const isGeneralRewardOutput = (
  reward: BonusTypes.Rewards.AnyRewardOutput,
): reward is BonusTypes.Rewards.RewardOutput =>
  !reward.rewardBands || !isArnoldBrosRewardBands(reward.rewardBands);

export const getRewards = (
  output: BonusTypes.Rewards.AnyDriverRewardsOutput,
): BonusTypes.Rewards.AnyRewardOutput[] => {
  if (isArnoldBrosDriverRewardsOutput(output)) {
    return output.rewards;
  }
  return output.rewards;
};

/**
 * Returns the maximum achievable points for a standard (non-Arnold) points
 * category by taking the highest band value. Returns undefined when bands are
 * absent, empty, or are Arnold-style (components-based), in which case the
 * caller should fall back to showing a single earned value.
 */
export const getMaxRewardBandPoints = (
  rewardBands?:
    | BonusTypes.Rewards.RewardBands
    | BonusTypes.Rewards.ArnoldBrosRewardBands,
): number | undefined => {
  if (!rewardBands || isArnoldBrosRewardBands(rewardBands)) {
    return undefined;
  }
  if (rewardBands.bands.length === 0) {
    return undefined;
  }
  return Math.max(...rewardBands.bands.map((b) => b.value));
};
